import useShowHideOnScroll from "@/hooks/useScrollToggle";
import { FC, memo } from "react";

import { ProfileScoreHeaderProps } from "../utils/types";
import PercentageDisplay from "./percentageDisplay";

const ProfileScoreHeader: FC<ProfileScoreHeaderProps> = (props) => {
  const { viewType, title, description, score } = props;
  const showComponent = useShowHideOnScroll(1000);

  const percentageDisplay = ["msite"].includes(viewType) ? (
    <div className="bg-state-surface-info-bold flex items-center justify-start gap-2 rounded-[128px] p-1">
      <PercentageDisplay score={score} viewType={viewType} />
      {score < 51 && showComponent && (
        <span className="pr-4 text-sm font-medium text-white">
          Profile Score
        </span>
      )}
    </div>
  ) : (
    <PercentageDisplay score={score} viewType={viewType} />
  );

  return (
    <div className="flex w-full items-center gap-3">
      {percentageDisplay}
      {["modal", "web"].includes(viewType) && (
        <div className="my-auto flex flex-1 shrink basis-0 flex-col gap-1 self-stretch">
          <div className="gap-2 self-start text-sm font-medium leading-none text-black">
            {title}
          </div>
          <div className="text-content-tertiary break-words text-xs font-normal">
            {description}
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(ProfileScoreHeader);
